/**
 * @generated SignedSource<<02638f2e8727b45498d5facc19a78e14>>
 * @relayHash 976837d13abb9b9131601925549fb05e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$variables = {
  cloudId: string;
};
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon">;
  };
};
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery = {
  response: starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$data;
  variables: starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": isAddLimitToNav3StarredFilterSidebarEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAddLimitToNav3StarredFilterSidebarEnabled_provider from '@atlassian/jira-relay-provider/src/is-add-limit-to-nav3-starred-filter-sidebar-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v5 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v6 = {
  "kind": "ScalarField",
  "name": "jql"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ],
  "type": "JiraCustomFilter"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "starredFiltersList_navigationAppsSidebarCommon"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "favouriteFilters",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": {
                        "order": "DESC"
                      },
                      "type": "FILTER"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 15
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "favouriteFiltersOld",
                "args": (v2/*: any*/),
                "concreteType": "JiraFilterConnection",
                "kind": "LinkedField",
                "name": "favouriteFilters",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraFilter"
                          },
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9",
    "metadata": {},
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": isAddLimitToNav3StarredFilterSidebarEnabled_provider
    }
  }
};
})();

(node as any).hash = "86a313b9769c9a6a731e02bed044f4d2";

export default node;
